/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsAccounts = {
  init: function($section){


    if(window.location.hash === '#recover') {
      $('#recover-password').show();
      $('.modal-bg').show();
    }

    $('.js-recover-password').on('click', function(e){
      e.preventDefault()
      $('#recover-password').show();
      $('.modal-bg').show();
    });

    $('.modal-bg').on('click', function() {
      $(this).hide();
      $('#recover-password').hide();
    })

    $('.cancel-recover-password').on('click', function(){
      $('#recover-password').hide();
      $('.modal-bg').hide();
    })

    $('.password-eye-icon').on('click', function() {
      $(this).find('.icon').toggle();
      var input_password = $(this).closest('form').find('[name="customer[password]"]')
      
      input_password.attr('type', input_password.attr('type') === 'password' ? 'text' : 'password')
    })

  },

  unload: function($section) {
    $('.js-recover-password').off();
    $('.cancel-recover-password').off();
  }
}

/******/ })()
;